import getStyle from './getStyle';
import isDocument from './isDocument';
import isWindow from './isWindow';

function isOverflowShown(value) {
  return /^(visible|auto)$/.test(value);
}

function isOverflowScroll(value) {
  return value === 'scroll';
}

export function isHorizontalScrollbarVisible(target) {
  if (isWindow(target)) {
    var _target$document$docu = target.document.documentElement,
        _scrollWidth = _target$document$docu.scrollWidth,
        _clientWidth = _target$document$docu.clientWidth;
    return _scrollWidth > _clientWidth;
  }

  if (isDocument(target)) {
    var _target$documentEleme = target.documentElement,
        _scrollWidth2 = _target$documentEleme.scrollWidth,
        _clientWidth2 = _target$documentEleme.clientWidth;
    return _scrollWidth2 > _clientWidth2;
  }

  var scrollWidth = target.scrollWidth,
      clientWidth = target.clientWidth;
  var isOverflowing = scrollWidth > clientWidth;
  var overflowX = getStyle(target, 'overflowX');

  if (overflowX == null) {
    return false;
  }

  return isOverflowing && isOverflowShown(overflowX) || isOverflowScroll(overflowX);
}
export function isVerticalScrollbarVisible(target) {
  if (isWindow(target)) {
    var _target$document$docu2 = target.document.documentElement,
        _scrollHeight = _target$document$docu2.scrollHeight,
        _clientHeight = _target$document$docu2.clientHeight;
    return _scrollHeight > _clientHeight;
  }

  if (isDocument(target)) {
    var _target$documentEleme2 = target.documentElement,
        _scrollHeight2 = _target$documentEleme2.scrollHeight,
        _clientHeight2 = _target$documentEleme2.clientHeight;
    return _scrollHeight2 > _clientHeight2;
  }

  var scrollHeight = target.scrollHeight,
      clientHeight = target.clientHeight;
  var isOverflowing = scrollHeight > clientHeight;
  var overflowY = getStyle(target, 'overflowY');

  if (overflowY == null) {
    return false;
  }

  return isOverflowing && isOverflowShown(overflowY) || isOverflowScroll(overflowY);
}
export default function isScrollbarVisible(target, axis) {
  switch (axis) {
    case 'vertical':
      return isVerticalScrollbarVisible(target);

    case 'horizontal':
      return isHorizontalScrollbarVisible(target);

    default:
      return isVerticalScrollbarVisible(target) || isHorizontalScrollbarVisible(target);
  }
}
//# sourceMappingURL=isScrollbarVisible.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-helpers/dist/esm/isScrollbarVisible.js
// module id = 524
// module chunks = 0 1